'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _step = require('../components/cartDetail/step1');

var _step2 = _interopRequireDefault(_step);

var _step3 = require('../components/cartDetail/step2');

var _step4 = _interopRequireDefault(_step3);

var _step5 = require('../components/cartDetail/step3');

var _step6 = _interopRequireDefault(_step5);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _actions3 = require('../../customer/actions');

var _actions4 = _interopRequireDefault(_actions3);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _history = require('linksoft/core/history');

var _history2 = _interopRequireDefault(_history);

var _utils = require('../components/utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    return {
        cart: state.cart,
        contact: state.customer.contact
    };
}

var mapDispatchToProps = {
    empty: _actions2.default.empty,
    changeAmount: _actions2.default.changeAmount,
    setStep: _actions2.default.setStep,
    updateCart: _actions2.default.update,
    loadContact: _actions4.default.loadContact,
    setProcessing: _actions2.default.setProcessing,
    updateDeliveryType: _actions2.default.updateDeliveryType
};

var CartDetail = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
    (0, _inherits3.default)(CartDetail, _React$Component);

    function CartDetail() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CartDetail);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CartDetail.__proto__ || (0, _getPrototypeOf2.default)(CartDetail)).call.apply(_ref, [this].concat(args))), _this), _this.isActive = function (step) {
            return _this.props.cart.step === step;
        }, _this.navClass = function () {
            var navClass = 'cart__navs';
            var step = _this.props.cart.step;
            if (step >= 1) {
                navClass += ' active--step1';
            }
            if (step >= 2) {
                navClass += ' active--step2';
            }
            if (step >= 3) {
                navClass += ' active--step3';
            }
            return navClass;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CartDetail, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var initialState = JSON.parse(this._root.parentNode.attributes['data-component-props'].value);
            this._root.parentNode.removeAttribute('data-component-props');
            this.props.updateCart(initialState.cart);

            // callback from PPL Parcelshop -> skip to transfer
            var pplParcelShopKey = initialState.cart.constants.filter(function (i) {
                return i.key === 'pplParcelShopKey';
            })[0].value;
            var type = _utils2.default.getQueryStringParam('type');
            if (type === pplParcelShopKey) {
                setTimeout(function () {
                    _this2.props.setStep(2);
                    var deliveryTypeId = parseInt(_utils2.default.getQueryStringParam('deliveryTypeId'));
                    _this2.props.updateDeliveryType(deliveryTypeId);
                }, 1);
            }

            setTimeout(function () {
                _this2.props.loadContact();
                var hash = _history2.default.location.hash;
                if (hash && hash.startsWith('#')) {
                    var step = parseInt(hash.substr(1));
                    if (step && !isNaN(step)) {
                        _this2.props.setStep(step);
                    }
                }
            }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var loading = !this.props.cart.totalPrice;
            return _react2.default.createElement(
                'section',
                {
                    className: 'cart cart--1',
                    ref: function ref(e) {
                        return _this3._root = e;
                    },
                    style: { minHeight: 400 }
                },
                _react2.default.createElement(
                    'div',
                    { className: 'container-fluid' },
                    _react2.default.createElement(
                        'nav',
                        { className: this.navClass() },
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'li',
                                { className: 'cart__nav cart__nav--1' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    Resx.App.ShoppingCart
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                { className: 'cart__nav cart__nav--2' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    Resx.App.TransportationAndPaymentTitle
                                )
                            ),
                            _react2.default.createElement(
                                'li',
                                { className: 'cart__nav cart__nav--3' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    Resx.App.DeliveryInformationAndSummaryTitle
                                )
                            )
                        )
                    ),
                    loading ? _react2.default.createElement(
                        'div',
                        { className: 'cart__steps', style: { height: 400 } },
                        _react2.default.createElement('div', { className: 'cart__step cart__step--1 step__loading' })
                    ) : _react2.default.createElement(
                        'div',
                        { className: 'cart__steps' },
                        _react2.default.createElement(_step2.default, this.props),
                        _react2.default.createElement(_step4.default, this.props),
                        _react2.default.createElement(_step6.default, this.props)
                    )
                )
            );
        }
    }]);
    return CartDetail;
}(_react2.default.Component)) || _class);
exports.default = CartDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/cart-detail.js
// module id = 1038
// module chunks = 0